// reactive variables for the users used in audience module

import { AudienceUserTableFragment } from '../operations/__generated__/fragments'
import { makeVar } from '@apollo/client'

export const audienceUsersSelectedVar = makeVar<AudienceUserTableFragment[]>([])
export const isAllUsersSelectedVar = makeVar<boolean>(false)
